'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createThemeStyle = function createThemeStyle(name, style, variant, status) {
  var base = name + '_' + style;
  if (typeof variant !== 'undefined') {
    base += '_' + variant;
  }
  if (typeof status !== 'undefined') {
    base += '_' + status;
  }
  return base;
};
var baseThemeReset = exports.baseThemeReset = {
  logo_small: undefined,
  openingHours: undefined,
  liveChat: undefined
};

// Adds a variant to an existing style
// addVariant('Button_color', 'primary) = 'Button_color_primary'
// addVariant('Button_color_hover', 'primary') = 'Button_color_primary_hover'
var addVariant = exports.addVariant = function addVariant(style, variant) {
  var split = style.split('_');
  var base = split[0] + '_' + split[1] + '_' + variant;
  return split.length === 3 ? base + '_' + split[2] : base;
};
exports.default = createThemeStyle;